<template>
  <lazy-component>
    <picture v-if="loaded">
      <template v-for="(size, sizeIndex) in sizes">
        <template v-for="(format, index) in formats">
          <source
            :key="sizeIndex + '_' + index"
            :media="`(max-width: ${size}px)`"
            :srcset="`${baseUrl}/${code}_${size}.${format}`"
            :type="`image/${format}`"
          />
        </template>
      </template>
      <img
        :src="`${baseUrl}/${code}.${formats[0]}`"
        :alt="alt"
        :title="title"
        class="img-responsive"
      />
    </picture>
  </lazy-component>
</template>

<script>
export default {
  name: "BiPicture",
  props: {
    code: {
      type: String
    },
    isLegacy: {
      type: Boolean,
      default: false
    },
    thumbFormats: {
      type: Array
    },
    thumbSizes: {
      type: Array
    },
    title: {
      type: String,
      default: "Image"
    },
    alt: {
      type: String,
      default: "Image"
    },
    thumbnail: {
      type: [String, Boolean],
      default: false
    },
    absolute: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loaded: false
    };
  },
  computed: {
    baseUrl() {
      if (this.isLegacy) {
        return "/static/img";
      } else {
        return "/app-static/images";
      }
    },
    formats() {
      let formats = this.thumbFormats;
      return formats;
    },
    sizes() {
      let sizes = this.thumbSizes;
      return sizes
        .map(size => {
          return parseInt(size);
        })
        .sort((a, b) => {
          return a - b;
        });
    }
  },
  mounted() {
    this.loaded = true;
  }
};
</script>

<style scoped lang="scss">
img {
  width: 100%;
}
</style>
